import { useTopPlaylists } from "@/lib/api";
import { Skeleton } from "@mui/material";
import PlaylistSwiper from "./PlaylistSwiper";

const TopOfGenre = ({ active, onPlay }) => {
  const { playlists, isLoading } = useTopPlaylists("toplist");

  const handlePlayed = (playlist) => {
    if (onPlay && typeof onPlay === "function") {
      onPlay(playlist);
    }
  };

  if (isLoading) {
    return (
      <Skeleton variant="rectangular" sx={{ width: "100%", height: "24rem" }} />
    );
  }

  return (
    <PlaylistSwiper
      playlists={playlists}
      active={active}
      onPlay={handlePlayed}
      prefix="Top of"
    />
  );
};

export default TopOfGenre;
